export default __webpack_public_path__ + "static/media/G.87b7aa7a.svg";